import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../components/AppDrawer';
import { useQuery } from '@tanstack/react-query';
import { getCustomerSegmentsForSelect, getRolesForSelect } from '../api/users';
import UserForm, { type UserFormValues } from './UserForm';

export interface UserFormDrawerProps {
  open: boolean;
  onClose: () => void;
  onSave: (values: UserFormValues) => void;
  saving: boolean;
}

const UserFormDrawer: React.FC<UserFormDrawerProps> = ({
  open,
  onClose,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<UserFormValues>();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
  }, [open, form]);

  const { data: roleOptions = [] } = useQuery({
    queryKey: ['roles-select'],
    queryFn: getRolesForSelect,
    enabled: open,
  });

  const { data: segmentOptions = [] } = useQuery({
    queryKey: ['customer-segments-select'],
    queryFn: getCustomerSegmentsForSelect,
    enabled: open,
  });

  return (
    <Drawer
      title="Create user"
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      destroyOnClose
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Create
          </Button>
        </div>
      }
    >
      <UserForm form={form} onFinish={onSave} roleOptions={roleOptions} segmentOptions={segmentOptions} />
    </Drawer>
  );
};

export default UserFormDrawer;

